import env from '../env';

export const sendPartnerFeatures = (autoActivation: boolean) => {
  chrome.runtime
    .sendMessage(env.kindred_extension_id, {
      type: 'partnerFeatures',
      autoActivation,
    })
    .catch(() => {
      console.log('Extension not ready or does not exist for partner features');
    });
};
